export default async () => {
    const handleScroll = () => {
        const elements = document.querySelectorAll(".highlight");
        elements.forEach((el) => {
            const rect = el.getBoundingClientRect();
            const isVisible = rect.top < window.innerHeight - 100 && rect.bottom >= 0;

            if (isVisible) {
                el.classList.add("visible");
                el.classList.remove("hidden");
            } else {
                el.classList.add("hidden");
                el.classList.remove("visible");
            }
        });
    };

    handleScroll();
    document.addEventListener("scroll", handleScroll);
};
